import { createFileRoute } from '@tanstack/react-router';
import { redirectLegacyVisualizationsToPortfolio } from './-redirect';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/')({
  beforeLoad: redirectLegacyVisualizationsToPortfolio,
});
